const apiKey = state => state.apiKey;
const visible = state => state.visible;
const mode = state => state.mode;
const q = state => state.q;
const queryFilters = state => state.queryFilters;
const autocompleteInfo = state => state.autocomplete;
const history = state => state.history;
const products = state => state.products;
const selected_category = state => state.selected_category;
const selected_category_name = state => state.selected_category_name;
const selected_param = state => state.selected_param;
const brandFacets = state => state.facets.brands;
const tagFacets = state => state.facets.tags;
const tagFacetsActual = state => state.facets_actual.tags;
const colorFacets = state => state.facets.colors;
const noveltyFacets = state => state.facets.novelty;
const hitFacets = state => state.facets.hit;
const availabilityFacets = state => state.facets.availability;
const categoryFacets = state => state.facets.categories;
const priceFacets = state => state.facets.prices;
const isMobile = state => state.isMobile;
const isOpenFacets = state => state.isOpenFacets;
const isAutocompleteMode = state => { return state.mode === 'start' && state.visible};
const isIE = state => state.isIE;
const hiddenByScroll = state => state.hiddenByScroll;
const sort = state => state.sort;
const pageSize = state => state.pageSize;
const currentPage = state => state.currentPage;
const totalHits = state => state.totalHits;
const priceRange = state => state.priceRange;
const priceSelected = state => state.priceSelected;
const selectedFacets = state => state.facets.selected;
const searchParam = state => state.searchParam;
const showSortMobile = state => state.showSortMobile;
const currentOpenFacet = state => state.currentOpenFacet;
const tips = state => state.tips;
const headerSelector = state => state.headerSelector;
const isWasSearch = state => state.isWasSearch;
const redirectUrl = state => state.redirectUrl;

// Доп функционал фильтра товаров категории
const isCategoryFilter = state => state.isCategoryFilter;

export default {
    apiKey,
    visible,
    mode,
    q,
    queryFilters,
    autocompleteInfo,
    history,
    products,
    selected_category,
    selected_category_name,
    selected_param,
    brandFacets,
    tagFacets,
    tagFacetsActual,
    colorFacets,
    noveltyFacets,
    hitFacets,
    availabilityFacets,
    categoryFacets,
    priceFacets,
    isMobile,
    isOpenFacets,
    isIE,
    hiddenByScroll,
    isAutocompleteMode,
    sort,
    pageSize,
    currentPage,
    totalHits,
    priceRange,
    priceSelected,
    selectedFacets,
    searchParam,
    showSortMobile,
    currentOpenFacet,
    tips,
    headerSelector,
    isWasSearch,
    redirectUrl,
    isCategoryFilter
};